export const CSS_PREFIX = 'wixui-';

export const formatClassNames = (
  semanticClassName: string | null,
  ...customClassNames: Array<string>
) => {
  const result: Array<string> = [];
  if (semanticClassName) {
    result.push(`${CSS_PREFIX}${semanticClassName}`);
  }
  customClassNames.forEach(className => {
    if (className) {
      // add each custom class with and without the prefix
      result.push(`${CSS_PREFIX}${className}`);
      result.push(className);
    }
  });
  return result.join(' ');
};
